import React from "react";
import createSvgIcon from "@material-ui/core/utils/createSvgIcon";

/**
 * author: Austin Andrews
 * id 4BA51088-9403-4E34-A829-1F31D8DE2646
 * name escalator-up
 * version: 4.8.95
 * url https://raw.githubusercontent.com/Templarian/MaterialDesign/master/svg/escalator-up.svg
 * tags
 * - Transportation + Other 
 */
export const EscalatorUpIcon = createSvgIcon(<><path d="M20 8H18.95L6.95 20H4C2.9 20 2 19.11 2 18C2 16.9 2.9 16 4 16H5.29L7 14.29V10C7 9.45 7.45 9 8 9H9C9.55 9 10 9.45 10 10V11.29L17.29 4H20C21.11 4 22 4.89 22 6C22 7.11 21.11 8 20 8M8.5 5C9.33 5 10 5.67 10 6.5C10 7.33 9.33 8 8.5 8C7.67 8 7 7.33 7 6.5C7 5.67 7.67 5 8.5 5M20.17 15.66L14.66 21.17L12.83 19.34L18.34 13.83L16.5 12H22V17.5L20.17 15.66Z" /></>, 'EscalatorUpIcon');
export default EscalatorUpIcon